import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { LoadingBlock } from '@/components/ui/feedback.tsx'
import { useCurrentUser } from '@/features/user/hooks.ts'
import { useSession } from '@/lib/auth-client.ts'
import { AppShell } from './app-shell.tsx'

/** Everything behind a session. Renders the shell so navigation never flashes. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const session = useSession()

  if (session.isPending) {
    return <LoadingBlock label="Memeriksa sesi…" />
  }

  if (!session.data?.user) {
    return <Navigate to="/" replace />
  }

  return <AppShell>{children}</AppShell>
}

/**
 * The admin surface. The API enforces this independently from the email
 * allowlist — this guard only keeps the UI from offering pages that would be
 * refused anyway.
 */
export function SuperAdminRoute({ children }: { children: ReactNode }) {
  const { data, isPending } = useCurrentUser()

  if (isPending) {
    return <LoadingBlock label="Memeriksa akses…" />
  }

  if (!data?.isSuperAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
